<div class="separator" *ngIf="isLast"></div>

<mat-list-item
  [id]="navItem?.optionId"
  tabindex="0"
  [style.position]="'relative'"
  [style.paddingLeft.px]="isSidebarOpen ? 16 : 7"
  [style.paddingRight.px]="isSidebarOpen ? 16 : 11"
  [class.active]="active()"
  [matTooltipClass]="'sidebar-nav-tooltip'"
  [class.active-expandable]="activeAndExpandable()"
  [matTooltip]="tooltip"
  [matTooltipShowDelay]="0"
  [matTooltipHideDelay]="0"
  [class.heading]="heading"
  [class.second-level]="navItem.expanded && secondLevel"
  (click)="onFirstLevelClick()"
  cdk-overlay-origin
  #popoverOrigin="cdkOverlayOrigin"
>
  <mat-icon
    matListIcon
    [fontSet]="navItem?.iconFont || 'bosch'"
    [fontIcon]="navItem?.icon"
    *ngIf="(showIcon && !isSidebarOpen) || navItem?.showIcon"
    class="nav-link-icon"
    [matBadge]="navItem.iconBadgeText | async"
    [matBadgeColor]="navItem.iconBadgeColor | async"
    >{{ navItem?.iconContext }}</mat-icon
  >
  <mat-icon
    *ngIf="heading"
    matListIcon
    fontSet="bosch"
    fontIcon="Bosch-Ic-arrow-expand-left"
  ></mat-icon>
  <span
    style="padding-left: 8px"
    class="nav-item-title"
    [ngClass]="{
      bold: navItem.isHeader,
      alert: showServiceRequestPendingAlert && isPreventiveQueue
    }"
  >
    {{ navItem?.title }}
  </span>
  <mat-icon
    *ngIf="expandable && hasLevel2Items()"
    fontSet="bosch"
    fontIcon="Bosch-Ic-arrow-expand-right"
    class="expand-icon"
    [@indicatorRotate]="expandedState()"
  ></mat-icon>
  <mat-icon
    *ngIf="arrowRight"
    fontSet="bosch"
    fontIcon="Bosch-Ic-arrow-expand-right"
    class="expand-icon"
  ></mat-icon>
</mat-list-item>
<ng-container *ngIf="expandable && hasLevel2Items()">
  <div
    [@bodyExpansion]="expandedState()"
    class="sub-nav-links-container"
    [class.sub-nav-links-expanded]="isSidebarOpen"
  >
    <ng-container *ngFor="let item of navItem?.items">
      <mat-list-item
        tabindex="0"
        class="sub-nav-link"
        [id]="item.optionId"
        [class.active]="item.active"
        [class.second-level]="secondLevel"
        (click)="onSecondLevelClick(item)"
      >
        <mat-icon
          matListIcon
          [fontSet]="item?.iconFont || 'bosch'"
          [fontIcon]="item?.icon"
          class="nav-link-icon"
          [matBadge]="item.iconBadgeText | async"
          [matBadgeColor]="item.iconBadgeColor | async"
          >{{ navItem?.iconContext }}</mat-icon
        >
        <span style="margin-left: 10px" matLine>{{ item?.title }}</span>
      </mat-list-item>
    </ng-container>
  </div>
</ng-container>
